import React, { useEffect } from 'react';
import { InvasionsHero } from '../components/guide/InvasionsHero';
import { ScheduleCallout } from '../components/guide/ScheduleCallout';
import { BossInvasions } from '../components/guide/BossInvasions';
import { JewelInvasions } from '../components/guide/JewelInvasions';
import { RewardTotals } from '../components/guide/RewardTotals';
import { GoldenInvasionTeaser } from '../components/guide/GoldenInvasionTeaser';
import { InvasionsWhy } from '../components/guide/InvasionsWhy';
import { HuntClosing } from '../components/guide/HuntClosing';
import { GuideSearch } from '../components/guide/search/GuideSearch';
export function InvasionsGuide() {
  useEffect(() => {
    document.title = 'Guía: Invasiones · MU Vanguard';
  }, []);
  return <main data-id="element-2840" data-mp="2igquszr7zqq9">
      <InvasionsHero data-id="element-2841" data-mp="2ih0e64hrezmz" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 md:pt-8 pb-6 md:pb-16" data-id="element-2842" data-mp="2wdvxcprq67gr">
        <div className="mb-4 md:mb-10" data-id="element-2843" data-mp="2rfm3qjlnfex9">
          <GuideSearch variant="compact" data-id="element-2844" data-mp="2rgnbof7dblar" />
        </div>
        <ScheduleCallout data-id="element-2845" data-mp="3vjgtx2dhodxc" />
        <BossInvasions data-id="element-2846" data-mp="3vka64iv7vvmv" />
        <JewelInvasions data-id="element-2847" data-mp="3vkrzn7qhvvr3" />
        <GoldenInvasionTeaser data-id="element-2848" data-mp="3vllaokwhl7f1" />
        <RewardTotals data-id="element-2849" data-mp="4ce4afdaufp8" />
        <InvasionsWhy data-id="element-2850" data-mp="4dp6iar3jfe8" />
      </div>
      <HuntClosing data-id="element-2851" data-mp="4f0dskjr35a3" />
    </main>;
}